<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-chip-group
          v-model="world"
          active-class="primary--text"
        >
          <v-chip
            v-for="tag in maps"
            :key="tag"
            :value="tag"
          >
            {{ tag }}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <template v-if="isOpenWold">
      <v-row>
        <v-col cols="12">
          <image-config />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <map-global-config/>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row>
        <v-col cols="12">
          <multimap-config />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import ImageConfig from '../../../components/configs/imageConfig.vue';
import MultimapConfig from '../../../components/configs/multimapConfig.vue';
import MapGlobalConfig from '../../../components/configs/mapGlobalConfig.vue';

export default {
  components: {
    ImageConfig,
    MultimapConfig,
    MapGlobalConfig
  },
  data () {
    return {
      maps: ['open world', 'multi-levels']
    }
  },
  computed: {
    isOpenWold () {
      return this.$store.state.project_config.world === 'open world'
    },
    world: {
      get () {
        return this.$store.state.project_config.world
      },
      set (val) {
        this.$store.dispatch('updateProjectConfig', { world: val })
      }
    }
  }
}
</script>
